import { createTheme } from "@mui/material/styles";
import { fontSans } from "./theme/tokens";

const theme = createTheme({
  typography: {
    fontFamily: fontSans,
    // The site sets no light text: MUI's light weight, the default for h1
    // and h2, is regular.
    fontWeightLight: 400,
  },
});

export default theme;
